export default __webpack_public_path__ + "static/media/fashion2.8a6e0b2f.jpg";